import { FormGroup } from "@angular/forms";
import { Document } from "./document";
import { TemplateAttribute } from "./template-attribute";
import { TemplateAttributeType } from "./template-attribute-type.enum";

export class DocumentViewModel {

    title: string;
    document: Document;
    form: FormGroup;
    selected = false;
  
    constructor(document: Document, form: FormGroup) {
      this.document = document;
      this.form = form;
      this.updateDocumentTitle();
    }
  
    public onDocumentChanged() {
      this.updateDocumentTitle();
    }
  
    private updateDocumentTitle() {
      if (this.document.template.titlePattern != null &&
        this.document.template.titlePattern.length > 0) {
        let tempTitle = this.document.template.titlePattern;
  
        this.document.template.areas.forEach(area => {
          area.attributes.forEach(attr => {
            const value = this.valueForAttribute(this.document, attr);
            const placeholder = '{' + attr.key + '}';
            tempTitle = tempTitle.replace(placeholder, value);
          });
        });
        this.title = tempTitle;
      }
    }
  
    private valueForAttribute(document: Document, attribute: TemplateAttribute): any {
      if (document == null || document.values == null) {
        return '';
      }
      const result = document.values.filter(v => v.key === attribute.key);
      if (result.length > 0) {
        if (attribute.type === TemplateAttributeType.BOOLEAN) {
          return result[0].value ? 'Ja' : 'Nein';
        }
        if (attribute.type === TemplateAttributeType.PHOTO) {
          return 'unsupported type PHOTO';
        }
        return result[0].value == null ? '' : result[0].value;
      } else {
        return '';
      }
    }
  }